import { toast } from "sonner";

import { useAssetsList } from "@/contexts/AssetsListContext";
import { UNSAVED_ASSETS_LIST_LABEL } from "@/components/AssetsList/constants";

/**
 * Appends an asset to the list open in the strip — the unsaved "Current list"
 * when nothing is loaded. Shared by the assets grid and the asset preview so
 * neither duplicates the append. The entry lands as an unsaved change, exactly
 * like a drag into the strip; Save persists it.
 */
export default function useAddAssetToList() {
  const { workingList, addAssetToWorkingList } = useAssetsList();

  /**
   * @input {asset: {_id: 'a1', mediaType: 'video'}, inTime: 2, outTime: 5, sourceMedia: {frameRate: 24}}
   * @output undefined
   */
  const addAssetToList = ({ asset, inTime, outTime, sourceMedia }) => {
    if (!asset) return;

    const wasAdded = addAssetToWorkingList({
      asset,
      inTime,
      outTime,
      sourceMedia,
    });
    if (!wasAdded) return;

    const currentListName = workingList.name || UNSAVED_ASSETS_LIST_LABEL;
    toast.success(`Added to "${currentListName}"`);
  };

  return { addAssetToList };
}
